module.exports = __webpack_public_path__ + "media/images/icons/twotone/box-plot-030f46664428dfe1b927c034f85c5b03.svg";